module.exports = __webpack_public_path__ + "img/a8.1bd7af85.png";